import React, { useState, useRef } from "react";
import "./HospitalGallery.css";

// Dynamically import all hospital gallery images
// function importAll(r) {
//   return r.keys().map(r);
// }
// const images = importAll(require.context("../../images/Hospital-images", false, /\\.(jpg|jpg|png)$/));

const images = [
  require("../../images/Hospital-images/IMG_4405-01.jpg"),
  require("../../images/Hospital-images/IMG_4327-01.jpg"),
  require("../../images/Hospital-images/IMG_4329-01.jpg"),
  require("../../images/Hospital-images/IMG_4344-01.jpg"),
  require("../../images/Hospital-images/IMG_4362-01.jpg"),
  require("../../images/Hospital-images/IMG_4397-01.jpg"),
  require("../../images/Hospital-images/IMG_4409-01.jpg")
];

const HospitalGallery = () => {
  const [current, setCurrent] = useState(0);
  const total = images.length;
  const touchStartX = useRef(null);

  // Swipe handlers for mobile
  const handleTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const deltaX = touchEndX - touchStartX.current;
    if (deltaX > 50) {
      // Swipe right (previous)
      setCurrent((prev) => (prev - 1 + total) % total);
    } else if (deltaX < -50) {
      // Swipe left (next)
      setCurrent((prev) => (prev + 1) % total);
    }
    touchStartX.current = null;
  };

  const nextImage = () => setCurrent((prev) => (prev + 1) % total);
  const prevImage = () => setCurrent((prev) => (prev - 1 + total) % total);

  return (
    <section className="hospital-gallery-section gradient-bg">
      <div className="container">
        <h2 className="gallery-title">Our Hospital in Pictures</h2>
        <p className="gallery-desc">
          Explore our world-class facility and compassionate care through these glimpses of our hospital environment.
        </p>
        <div className="carousel-container">
          <div className="carousel-image-wrapper"
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
          >
            <img
              src={images[current]}
              alt="Hospital view"
              className="carousel-image"
            />
          </div>
          <div className="carousel-arrows-row">
            <button className="carousel-nav-btn prev" onClick={prevImage} aria-label="Previous image">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#F6F9FC"/><path d="M14.5 17L10 12.5L14.5 8" stroke="#205080" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
            <button className="carousel-nav-btn next" onClick={nextImage} aria-label="Next image">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="12" fill="#F6F9FC"/><path d="M9.5 17L14 12.5L9.5 8" stroke="#205080" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </button>
          </div>
          <div className="carousel-counter">
            {current + 1} / {total}
          </div>
        </div>
        <div className="carousel-dots">
          {images.map((_, idx) => (
            <span
              key={idx}
              className={`carousel-dot${idx === current ? " active" : ""}`}
              onClick={() => setCurrent(idx)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HospitalGallery;
